import { render } from "./InstructivosPage.vue?vue&type=template&id=0b648c8a&scoped=true"
import script from "./InstructivosPage.vue?vue&type=script&lang=js"
export * from "./InstructivosPage.vue?vue&type=script&lang=js"

import "./InstructivosPage.vue?vue&type=style&index=0&id=0b648c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b648c8a"]])

export default __exports__